module.exports = __webpack_public_path__ + "assets/b247b85dfcc5c72bc824353c5307ef26.png";